<div class="container" [hidden]="isInitialLoading">
    <form (submit)="submitForm(signInForm)" #signInForm="ngForm">
        <h3>{{ welcomeText }}</h3>
        <div *ngIf="!visitorLogged">
            <h5>Please log your visit.</h5>
            <div class="row">
                <div class="col-sm-12 col-12">
                    <div class="form-group">
                        <label>First Name</label>
                        <input type="text" class="form-control" [(ngModel)]="visitor.firstName" name="firstName" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-12">
                    <div class="form-group">
                        <label>Last Name</label>
                        <input type="text" class="form-control" [(ngModel)]="visitor.lastName" name="lastName" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-12">
                    <div class="form-group">
                        <label>Company</label>
                        <input type="text" class="form-control" [(ngModel)]="visitor.company" name="company" />
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 10px">
                <div class="col-sm-12 col-12">
                    <button type="submit" class="btn btn-success">
                        <span>Submit</span>
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="visitorLogged">
            <h5>Please review the following safety notices for this site.</h5>
            <ul>
                <li>Trenching in East part of the yard.</li>
                <li>Overhead powerlines at 18'.</li>
                <li>Steel toed shoes recommended.</li>
            </ul>
        </div>
    </form>
</div>
